'use client';

import { alertModalAtom } from '@/atom/modal';
import { useAtom, useAtomValue } from 'jotai';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function AlertModal() {
  const router = useRouter();
  const pathname = usePathname();
  const [alertModal, setAlertModal] = useAtom(alertModalAtom);

  const [visible, setVisible] = useState(false);
  const [fadeType, setFadeType] = useState<'in' | 'out'>('in');

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (!alertModal.visible) {
      setFadeType('out');
      timer = setTimeout(() => {
        setVisible(false);
      }, 200);

      return () => {
        if (timer) {
          clearTimeout(timer);
        }
      };
    } else {
      setVisible(true);
      setFadeType('in');
      const isNotHidden = document.body.style.overflowY !== 'hidden';
      if (isNotHidden) {
        document.body.style.overflowY = 'hidden';
      }

      return () => {
        if (isNotHidden) document.body.style.overflowY = 'auto';
      };
    }
  }, [alertModal.visible]);

  // useEffect(() => {
  //   setAlertModal({ visible: false });
  // }, [pathname]);

  if (!visible) {
    return null;
  }

  return (
    <div
      className={`fixed w-full max-w-480pxr top-0 z-[100] h-dvh overflow-hidden bg-custom-black/60 flex items-center justify-center ${
        fadeType === 'in' ? 'animate-[fadeIn_300ms_ease-in-out]' : 'animate-[fadeOut_200ms_ease-in-out]'
      }`}
      onClick={() => {
        alertModal.onOuterClick?.();
      }}
    >
      {alertModal.visible && (
        <div className='bg-white rounded-12pxr min-w-260pxr max-w-400pxr' onClick={(e) => e.stopPropagation()}>
          <div className='px-24pxr py-28pxr flex flex-col gap-8pxr'>
            <h2 className='text-gray-900 body-16-md text-center whitespace-pre-line'>{alertModal.title}</h2>
            <p className='text-gray-700 body-14-regular text-center whitespace-pre-line'>{alertModal.message}</p>
            <p className='text-gray-700 body-12-regular text-center whitespace-pre-line'>{alertModal.subMessage}</p>
          </div>
          <button
            className='w-full border-t border-gray-300 h-50pxr flex items-center justify-center body-16-md text-point-500'
            onClick={() => {
              alertModal.onConfirm?.();
            }}
          >
            확인
          </button>
        </div>
      )}
    </div>
  );
}
